export enum SubscriptionTypeEnum {
  VIDEO = 'video',
  CONSULTANCY = 'consultation',
  VIDEO_CONSULTANCY = 'video_consultation'
}
